// ============================================================================
// BreachCheckBadge — SoulSearch Phase B
// ============================================================================
// Badge yang tampil di finding card kalau email/phone terkena breach.
// Props: breaches[], lang
// ============================================================================

import React, { useState } from 'react';
import { AlertTriangle, ChevronDown, ChevronUp, Shield } from 'lucide-react';

export default function BreachCheckBadge({ breaches = [], lang = 'id' }) {
  const [expanded, setExpanded] = useState(false);
  if (!breaches || breaches.length === 0) {
    return (
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 5,
                    padding: '3px 8px', borderRadius: 6,
                    background: 'rgba(0,255,136,0.10)', border: '1px solid rgba(0,255,136,0.30)' }}>
        <Shield size={10} color="var(--color-green)" />
        <span style={{ fontSize: 9, fontFamily: 'IBM Plex Mono', fontWeight: 700,
                       color: 'var(--color-green)' }}>
          {lang === 'id' ? 'Tidak ada breach' : 'No breaches found'}
        </span>
      </div>
    );
  }

  const highSeverity = breaches.filter(b => b.severity === 'high').length;

  return (
    <div>
      <button
        type="button"
        onClick={() => setExpanded(v => !v)}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 5,
          padding: '3px 8px', borderRadius: 6, cursor: 'pointer',
          background: 'rgba(255,45,85,0.12)', border: '1px solid rgba(255,45,85,0.40)',
          color: 'var(--color-red)',
        }}>
        <AlertTriangle size={10} />
        <span style={{ fontSize: 9, fontFamily: 'IBM Plex Mono', fontWeight: 700 }}>
          {breaches.length} {lang === 'id' ? 'breach ditemukan' : 'breaches found'}
          {highSeverity > 0 && ` (${highSeverity} high)`}
        </span>
        {expanded ? <ChevronUp size={10} /> : <ChevronDown size={10} />}
      </button>

      {expanded && (
        <div style={{
          marginTop: 6, padding: '8px 10px', borderRadius: 8,
          background: 'rgba(255,45,85,0.06)', border: '1px solid rgba(255,45,85,0.20)',
          display: 'flex', flexDirection: 'column', gap: 6,
        }}>
          {breaches.map((b, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span style={{
                fontSize: 8, fontFamily: 'IBM Plex Mono', fontWeight: 700,
                padding: '1px 5px', borderRadius: 3, flexShrink: 0,
                background: b.severity === 'high' ? 'rgba(255,45,85,0.20)' : 'rgba(255,214,10,0.15)',
                color: b.severity === 'high' ? 'var(--color-red)' : 'var(--color-yellow)',
              }}>
                {b.severity?.toUpperCase()}
              </span>
              <div>
                <p style={{ fontSize: 9, fontFamily: 'IBM Plex Mono', fontWeight: 700,
                             color: 'var(--text-hi)', margin: 0 }}>
                  {b.breach_name}
                </p>
                <p style={{ fontSize: 8, color: 'var(--text-mute)', margin: 0 }}>
                  {b.breach_date} · {(b.exposed_data || []).slice(0, 3).join(', ')}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
